export default "__VITE_ASSET__D3w53jFJ__";